

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";
  import {BoPanel, IOnOffHandlers} from "bonomo/dist";
  import {IErrors} from "@/model/IErrors";
  import ShortUserCard from "@/components/user/ShortUserCard.vue";
  import {Prop, Watch} from "vue-property-decorator";
  import Datim from "@/components/shared/Datim.vue";
  import {ILocker2} from "@/model/Locker/lockerInterfaces";
  import LockerSearch from "@/components/locker/widget/LockerSearch.vue";
  import {UrlHelper} from "@/helpers/UrlHelper";
  import LTransferDestinations from "@/components/locker/modules/LTransferDestinations.vue";
  import {EPermissionActions} from "@/model/EPermissionActions";
  import ChannelSelector from "@/components/shared/ChannelSelector.vue";
  import LLandings from "@/components/locker/widget/LLandings.vue";
  import UserChip from "@/components/shared/chips/UserChip.vue";
  import LandingVersion from "@/components/locker/widget/LLandingVersion.vue";
  import LQrCode from "@/components/locker/widget/LQrCode.vue";
  import LLandingVersion from "@/components/locker/widget/LLandingVersion.vue";
  import LScreenType from "@/components/locker/widget/LScreenType.vue";
  import LLaLigaCompetition from "@/components/locker/widget/LLaLigaCompetition.vue";
  import LockerNav from "@/components/locker/widget/LockerNav.vue";
  import {uiBus} from "@/plugins/uiBus";
  import {IShortLocker} from "@/model/shortInterfaces";

  const locker2Module = namespace("locker2Module");
  const lockerModule = namespace("lockerModule");

  @Component({
    components: {
      LLaLigaCompetition,
      LockerNav,
      LLandingVersion,
      BoPanel,
      ChannelSelector,
      Datim,
      LLandings,
      LockerSearch,
      LQrCode,
      LScreenType,
      LTransferDestinations,
      LandingVersion,
      ShortUserCard,
      UserChip,
    }
  })
  export default class Locker extends Vue {

    @Prop()
    protected lockerId!: number;

    @locker2Module.Getter('locker')
    locker!: ILocker2;
    @locker2Module.Getter('errors')
    errors!: IErrors;
    @locker2Module.Action('setFeature')
    setFeature!: (params: {lockerId: number, data: object}) => void;
    @locker2Module.Action('updateSim')
    updateSim!: (params: {lockerId: number, sim: string | null}) => Promise<any>;

    simInput: string = '';
    simSaving: boolean = false;
    laLigaEditing: boolean = false;
    landingsEditing: boolean = false;
    loading: boolean = true;
    // submitting: boolean = false;
    qrEditing: boolean = false;
    landingVersionEditing: boolean = false;
    screenTypeEditing: boolean = false;

    // COMPUTED

    get anyEditing(): boolean {
      // have to put in consts to make sure reactivity happens - at least this used to be the practice
      const laLigaEditing = this.laLigaEditing;
      const landingsEditing = this.landingsEditing;
      const qrEditing = this.qrEditing;
      const landingVersionEditing = this.landingVersionEditing;
      const screenTypeEditing = this.screenTypeEditing;
      return laLigaEditing || landingsEditing || qrEditing || landingVersionEditing || screenTypeEditing;
    }

    get canEdit(): boolean {
      return this.$canAction(EPermissionActions.ACTION_LOCKERS_UPDATE);
    }

    get canInstall(): boolean {
      return this.$canAction(
        EPermissionActions.ACTION_LOCKERS_INSTALL
      );
    }

    get oldUrl(): string {
      return UrlHelper.mayorLocker(this.lockerId);
    }

    created() {
      // this.subscribes = this.$ons({
      //   // 'backend.call.OK.lockerLoaded': this.onLockerLoaded,
      //   // 'backend.call.KO': this.onLockerLoadedKO,
      // });
    }
    beforeDestroy() {
      // this.$offs(this.subscribes);
    }

    @Watch('locker.sim', {immediate: true})
    onLockerSimChange(val: string | null) {
      this.simInput = val || '';
    }

    loadData() {
      this.$store.dispatch('locker2Module/fetchLocker2', this.lockerId);
    }

    async onSaveSim() {
      this.simSaving = true;
      await this.updateSim({lockerId: this.lockerId, sim: this.simInput || null});
      this.simSaving = false;
      uiBus.emit('success', this.$t('lockers.locker.fields.sim.saved'));
    }

    onToggleDirectoryDelivery() {
      this.setFeature({
        lockerId: this.lockerId,
        data: {directory_delivery: !this.locker.directory_delivery},
      });
    }
    onToggleLaLiga() {
      this.setFeature({
        lockerId: this.lockerId,
        data: {la_liga: !this.locker.la_liga},
      });
    }
    onToggleLocker23Feature() {
      this.setFeature({
        lockerId: this.lockerId,
        data: {locker23_feature: !this.locker.locker23_feature},
      });
    }
    onToggleDeliveryByPhone() {
      this.setFeature({
        lockerId: this.lockerId,
        data: {delivery_by_phone: !this.locker.delivery_by_phone},
      });
    }
    onToggleDirectoryDeliveries24() {
      this.setFeature({
        lockerId: this.lockerId,
        data: {directory_deliveries_24: !this.locker.directory_deliveries_24},
      });
    }
    onToggleDirectoryDeliveries25() {
      this.setFeature({
        lockerId: this.lockerId,
        data: {directory_deliveries_25: !this.locker.directory_deliveries_25},
      });
    }
    onToggleShouldSendReminders() {
      this.setFeature({
        lockerId: this.lockerId,
        data: { should_send_reminders: !this.locker.should_send_reminders},
      });
    }
    onToggleOnlyLocalDelivery() {
      this.setFeature({
        lockerId: this.lockerId,
        data: {only_local_delivery: !this.locker.only_local_delivery},
      });
    }

  }

